import { AxiosResponse } from "axios";
import { API_ROUTE } from "../const/apiRoute";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { RedirectTableDataResponse } from "../model/TableRedirectPage";
import { api, api3 } from "../library/axios";
import { isNullOrUndefined } from "../_base/extension/StringExtension";
import { NotificationExtension } from "../_base/extension/NotificationExtension";
export const getlistRedirect = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api3.get(
      `${API_ROUTE.GET_REDIRECT}?${query}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
export const CreateRedirect = async (
  value: RedirectTableDataResponse
): Promise<any> => {
  try {
    const response: AxiosResponse = await api3.post(
      API_ROUTE.REDIRECT_CREATE,
      value
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
export const EditRedirect = async (
  value: RedirectTableDataResponse
): Promise<any> => {
  try {
    const response: AxiosResponse = await api3.post(
      API_ROUTE.REDIRECT_UPDATE,
      value
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
export const DetailRedirect = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api3.get(
      `${API_ROUTE.REDIRECT_DETAIL}${query}`
    );
    return response;
  } catch (error) {
    HanderResponse(error);
  }
};
export const DeleteRedirect = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api3.post(
      `${API_ROUTE.REDIRECT_DELETE}/${query}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};


// Hàm để cập nhật file excel SEO sản phẩm
export const UpdatefilexcelRedirect = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_FILEEXCEL_REDIRECT,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};